import { useEffect, useState, useCallback, useMemo } from "react";

const ADDON_SUPPORTED = "1.26.44";

export default function useStatus() {
  const [services, setServices] = useState([]);
  const [global, setGlobal] = useState({
    status: "Loading...",
    color: "green",
    lastUpdated: ""
  });

  // ✅ Stable checks object (fixes ESLint + prevents re-creation every render)
  const checks = useMemo(() => ({
    async minecraftAPI() {
      try {
        const res = await fetch(
          "https://raw.githubusercontent.com/RealModking/Addon-Status-Minecraft-Bedrock-Update/refs/heads/main/MinecraftVersion.json",// change if that link breaks to this https://raw.githubusercontent.com/DaniCraftYT25/Minecraft-BedrockAPI/refs/heads/main/version.json old https://raw.githubusercontent.com/dguerraaraque-a11y/Minecraft-BedrockAPI/refs/heads/main/version.json
          { cache: "no-store" }
        );

        if (!res.ok) throw new Error();

        const json = await res.json();
        const version = json.latest?.version || json.latest;

        if (version !== ADDON_SUPPORTED) {
          return { status: "Outdated", color: "orange", info: version };
        }

        return { status: "Online", color: "green", info: version };
      } catch {
        return { status: "Offline", color: "red" };
      }
    }
  }), []);

  // ✅ Now properly depends on stable `checks`
  const loadStatus = useCallback(async () => {
    const results = await Promise.all([
      checks.minecraftAPI()
    ]);

    const serviceList = [
      { name: "Minecraft API", ...results[0] }
    ];

    setServices(serviceList);

    let globalStatus = "All Systems Operational";
    let color = "green";

    if (serviceList.some(s => s.status === "Offline")) {
      globalStatus = "Major Outage";
      color = "red";
    } else if (serviceList.some(s => s.status === "Outdated")) {
      globalStatus = "Degraded Performance";
      color = "orange";
    }

    setGlobal({
      status: globalStatus,
      color,
      lastUpdated: new Date().toLocaleTimeString()
    });
  }, [checks]);

  // ✅ Auto refresh system
  useEffect(() => {
    loadStatus();

    const interval = setInterval(loadStatus, 10000);
    return () => clearInterval(interval);
  }, [loadStatus]);

  return { services, global };
}